import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }

import Pagination from '@/components/Pagination.vue'
import { useRouter } from 'vue-router'
import { getCurrentInstance, reactive, ref, onMounted } from 'vue'
import { getBrandListApi } from '@/apis/brand'
import Keys from '@/constant/key'
import { dateFormat, getYesterday, joinParams } from '@/utils/index'
import { useStore } from '@/store'
import { getCityListApi } from '@/apis/others'
import { CityM } from '@/models/others'


export default /*@__PURE__*/_defineComponent({
  __name: 'ChannelProductData',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const router = useRouter()
const store = useStore()

const today = new Date()
const filters = reactive({
        date: getYesterday(), 
        brand_name: '',
        citys: [],
        product_name: '',
        if_chudan: '',   
        brand_id: '',
        cat_id: '',
        start_maolilv: '',
        end_maolilv: '',
        type: 1,
        page: 1, // 当前页码
        page_size: 10, // 每页显示条数
})
const state =reactive({
    dialogVisible: false,
    props:{
        expandTrigger: 'hover',
        value:'id',
        label:'lable',
        checkStrictly: true,
        children:'options'
    },
    city:'',
    options:[],
    all_count:'',
    chudan_count:'',
    chudanlv:'',
})
const tableData = ref([])
const total = ref(0)
const disabledStartDate = (date) => {
    const currentDate = new Date(); // 获取当前日期
    const cutoffDate = new Date('2024-12-04'); // 数据从 2024 年 12 月 3 日开始

    // 禁用条件：小于 2024-12-03 或大于等于今天
    return date.getTime() <= cutoffDate.getTime()- 24*60*60*1000  || date.getTime() >= currentDate.setHours(0, 0, 0, 0);
};
// 获取列表数据
const getList = () => {
    proxy.$http.get('/channel_product/allproduct/get_channel_data_list', {
        ...filters,
        citys: filters.citys.join(',')
    }).then(res => {
        const { code, data, msg,count } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        tableData.value = data.data
        total.value = data.total
        state.all_count = data.all_count
        state.chudan_count = data.chudan_count
        state.chudanlv = data.chudanlv
    })
}
const cityList = ref<CityM[]>([])
const getCityList = async () => {
    const {code, data, msg} = await getCityListApi() as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    cityList.value = data
}
getCityList()
const search = () => {
    //结束毛利不能小于开始毛利且开始和结束毛利不能为空
    //有开始没结束或者又结束没开始才提醒
    if (filters.start_maolilv && !filters.end_maolilv) {
        return proxy.$message({ type: 'error', message: '结束毛利不能为空' })
    }
    if (!filters.start_maolilv && filters.end_maolilv) {
        return proxy.$message({ type: 'error', message: '开始毛利不能为空' })
    }
    const startMaolilv = Number(filters.start_maolilv);
    const endMaolilv = Number(filters.end_maolilv);

    if (endMaolilv < startMaolilv) {
        return proxy.$message({ type: 'error', message: '结束毛利不能小于开始毛利' });
    }
    filters.page = 1
    getList()
}
const onPreExport = async () => {
    window.open(`${Keys.baseUrl}/channel_product/allproduct/get_channel_data_list?${joinParams({...filters, type: 2, citys: filters.citys.join(',') , user_id: store.state.user.userInfo.id })}`);
}
const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}

onMounted(() => {
    getList()
    getBrandListApi()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.brand_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.brand_name) = $event)),
        placeholder: "品牌名称",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.product_name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.product_name) = $event)),
        placeholder: "商品名称",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        modelValue: filters.cat_id,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.cat_id) = $event)),
        clearable: "",
        filterable: "",
        placeholder: "请选择商品类型",
        class: "filter-item"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "蛋糕",
            value: "蛋糕"
          }),
          _createVNode(_component_el_option, {
            label: "零食小吃",
            value: "零食小吃"
          }),
          _createVNode(_component_el_option, {
            label: "花",
            value: "花"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _cache[14] || (_cache[14] = _createElementVNode("span", {
        class: "filter-item",
        style: {"color":"#606266"}
      }, "毛利率区间：", -1)),
      _createVNode(_component_el_input, {
        clearable: "",
        style: {"width":"170px","vertical-align":"middle","margin":"0 10px 10px 0 !important"},
        type: "number",
        placeholder: "起始毛利率",
        modelValue: filters.start_maolilv,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.start_maolilv) = $event)),
        modelModifiers: { trim: true },
        onInput: _cache[4] || (_cache[4] = ($event: any) => (filters.start_maolilv = filters.start_maolilv.replace(/[^0-9.]/g, '').slice(0, 3)))
      }, {
        append: _withCtx(() => _cache[10] || (_cache[10] = [
          _createTextVNode("%")
        ])),
        _: 1
      }, 8, ["modelValue"]),
      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_input, {
        clearable: "",
        style: {"width":"170px","vertical-align":"middle","margin":"0 10px 10px 0 !important"},
        type: "number",
        placeholder: "结束毛利率",
        modelValue: filters.end_maolilv,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.end_maolilv) = $event)),
        modelModifiers: { trim: true },
        onInput: _cache[6] || (_cache[6] = ($event: any) => (filters.end_maolilv = filters.end_maolilv.replace(/[^0-9.]/g, '').slice(0, 3)))
      }, {
        append: _withCtx(() => _cache[11] || (_cache[11] = [
          _createTextVNode("%")
        ])),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.citys,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.citys) = $event)),
        multiple: "",
        clearable: "",
        filterable: "",
        placeholder: "请选择城市",
        style: {"width":"300px"},
        "collapse-tags": true,
        "max-collapse-tags": 2
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cityList.value, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.name,
              value: item.name
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (onPreExport()))
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [
          _createTextVNode("导出")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "index" }),
        _createVNode(_component_el_table_column, {
          prop: "brand_id",
          label: "品牌ID"
        }),
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "product_id",
          label: "商品ID"
        }),
        _createVNode(_component_el_table_column, {
          prop: "product_name",
          label: "商品名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "spec_name",
          label: "规格"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cat_id",
          label: "商品类别"
        }),
        _createVNode(_component_el_table_column, {
          prop: "price",
          label: "售价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "clearing_price",
          label: "供货价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "maolilv",
          label: "毛利率"
        }),
        _createVNode(_component_el_table_column, {
          prop: "citys",
          label: "开通城市",
          "show-overflow-tooltip": ""
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _cache[16] || (_cache[16] = _createElementVNode("div", { style: {"color":"#9c9494","font-size":"small"} }, "注：该列表以商品规格统计，以天级更新数据", -1))
  ]))
}
}

})